export default __webpack_public_path__ + "static/media/service-image1.704e530a.jpg";